import VehicleInfoDetailModal from './vehicle-info-detail-modal.vue'
export default VehicleInfoDetailModal
